// extracted by mini-css-extract-plugin
export var emptyState = "_6r-d";
export var statCard = "_6r-c";
export var table = "_6r-0";
export var tableCell = "_6r-4";
export var tableCellClickable = "_6r-5 _6r-4";
export var tableCellDefault = "_6r-6 _6r-4";
export var tableCellEmpty = "_6r-8";
export var tableCellWithValue = "_6r-7";
export var tableContainer = "_6r-e";
export var tableHeaderWeight = "_6r-1";
export var tableHeaderZone = "_6r-2";
export var tableRowHeader = "_6r-3";
export var viewModeButton = "_6r-9";
export var viewModeButtonActive = "_6r-a _6r-9";
export var viewModeButtonInactive = "_6r-b _6r-9";